@if (alertInfo.show) {
  <ngb-alert
    [type]="alertInfo.type"
    (closed)="alertInfo.show = false"
    >
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-4 mt-2">
      <autocomplete-field [label]="'Company'" [placeholder]="'Search...'"
        [inputFormControl]="getRequestCompanyAutocomplete()"
        [displayKeyValue]="true" (valueChange)="onCompanySelected($event)" [apiService]="customerService"
        [apiMethod]="'list'" [nameApiSearch]="'companyName'" [minChars]="1" [useApiSearch]="true" [optionsKey]="'customers'"
        [valueOption]="'companyName'" [keyOption]="'customerId'" [useLazyLoading]="true" [pageSize]="20" />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getRequestNameInput()"
        label="Name "
        placeholder="Name"
        [readonly]="readonlyRequestForm"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getRequestSurnameInput()"
        label="Surname"
        placeholder="Surname"
        [readonly]="readonlyRequestForm"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getRequestClientTypeInput()"
        label="Client Type"
        placeholder="Client Type"
        [readonly]="readonlyRequestForm"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getRequestTelInput()"
        label="Tel"
        placeholder="Tel"
        [readonly]="readonlyRequestForm"
        />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field
        type="text"
        [inputFormControl]="getRequestEmailInput()"
        label="Email"
        placeholder="Email"
        [readonly]="readonlyRequestForm"
        />
    </div>
  </div>
</form>
